<template>
  <div class="login" style="text-align: center; align-items: center">
    <div class="header">
      <span>{{ $t("login.welcomeToSensemore") }}</span>
      <h2 v-if="this.customer">{{ this.customer.name }}</h2>
      <h2 v-else><em class="el-icon-loading"></em></h2>
      <el-image
        v-if="customer.preferences.logo"
        :src="customer.preferences.logo"
        fit="fill"
        style="margin-bottom: 30px; max-width: 300px"
      ></el-image>
    </div>
    <el-card style="align-items: center; position: relative">
      <languageButton style="position: absolute; right: 20px"></languageButton>
      <h2>{{ $t("login.login") }}</h2>
      <el-form class="login-form" :model="model" :rules="rules" ref="form">
        <el-form-item prop="email">
          <el-input
            :disabled="!this.customer"
            @keyup.enter.native="submit($event)"
            v-model="model.email"
            :placeholder="$t('login.email')"
            prefix-icon="fas fa-user"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            :disabled="!this.customer"
            @keyup.enter.native="submit($event)"
            v-model="model.password"
            :placeholder="$t('login.password')"
            type="password"
            prefix-icon="fas fa-lock"
          ></el-input>
        </el-form-item>
        <!-- <vue-recaptcha
          v-if="reCaptchaCount >= 3"
          sitekey="6LfSW8AaAAAAAERgH1hIT1OdXURN5ccyxm_5nThE"
          ref="invisibleRecaptcha"
          @verify="onVerify"
          @expired="onExpired"
          :loadRecaptchaScript="true"
        >
        </vue-recaptcha> -->
        <el-form-item style="margin: 0">
          <a
            @click="showResetPasswordForm = true"
            style="float: right"
            href="#"
            >{{ $t("forgotpassword.forgotpassword") }}</a
          >
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="!this.customer"
            :loading="status.loggingIn"
            class="login-button"
            type="primary"
            @click="submit($event)"
            block
            >{{ $t("login.login") }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog
      :title="$t('forgotpassword.resetyourpassword')"
      width="30%"
      :visible.sync="showResetPasswordForm"
    >
      <el-form
        :model="forgotpassword"
        :rules="forgotpasswordRules"
        ref="forgotpasswordform"
      >
        <el-form-item prop="email" :label="$t('forgotpassword.email')">
          <el-input
            :disabled="!this.customer"
            v-model="forgotpassword.email"
            :placeholder="$t('login.email')"
            prefix-icon="fas fa-user"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <vue-recaptcha
            sitekey="6LfSW8AaAAAAAERgH1hIT1OdXURN5ccyxm_5nThE"
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            :loadRecaptchaScript="true"
          >
          </vue-recaptcha>
           -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sendforgotpassword()" block>{{
            $t("forgotpassword.send")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import VueRecaptcha from "vue-recaptcha";
import langTR from "element-ui/lib/locale/lang/tr-TR";
import langEN from "element-ui/lib/locale/lang/en";
import langRU from "element-ui/lib/locale/lang/ru-RU";
import langZHTW from "element-ui/lib/locale/lang/zh-TW";
import langZHCH from "element-ui/lib/locale/lang/zh-CN";
import langDE from "element-ui/lib/locale/lang/de";
import elLocale from "element-ui/lib/locale";
import languageButton from "./Language";
import dayjs from "dayjs-ext";
import axios from "axios";

export default {
  name: "login",
  components: {
    languageButton,
    // VueRecaptcha,
  },
  async created() {
    // (optional) Wait until recaptcha has been loaded.
    await this.$recaptchaLoaded();
  },
  data() {
    return {
      showResetPasswordForm: false,
      // reCaptcha: null,
      model: {
        email: "",
        password: "",
      },
      forgotpassword: {
        email: "",
      },
      forgotpasswordRules: {
        email: [
          {
            required: true,
            message: this.$t("login.requireemail"),
            trigger: "blur",
          },
        ],
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t("login.requireemail"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.requirepassword"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("account", ["status", "customer"]),
    language: {
      get() {
        return this.$i18n.locale;
      },
    },
  },
  watch: {},
  methods: {
    ...mapActions("account", ["login", "logout"]),
    async sendforgotpassword() {
      
      const token = await this.$recaptcha("login");
      console.log(token)
      if (!token) {
        this.$message({
          type: "error",
          message: this.$t("login.clickReCaptcha"),
        });
      } else {
        this.$refs["forgotpasswordform"].validate((valid) => {
          if (valid) {
            var body = {
              email: this.forgotpassword.email,
              reCaptcha: token,
            };
            axios
              .post(
                `${process.env.VUE_APP_APIURL}/forgotpassword/${this.customer._id}`,
                body
              )
              .then(() => {
                this.reCaptcha = null;
                this.$message.success(this.$t("forgotpassword.emailsend"));
                this.showResetPasswordForm = false;
              });
          } else {
            return false;
          }
        });
      }
    },
    async submit(event) {
      const token = await this.$recaptcha("login");
      if (!token) {
        this.$message({
          type: "error",
          message: this.$t("login.clickReCaptcha"),
        });
      } else {
        event.preventDefault();
        let valid = await this.$refs.form.validate();
        if (!valid) {
          return;
        } else {
          this.login({
            email: this.model.email,
            password: this.model.password,
            reCaptcha: token,
          });
        }
      }
    },
    handleLanguage(command) {
      this.$i18n.locale = command;
      localStorage.setItem("language", command);
      switch (command) {
        case "tr":
          dayjs.locale("tr");
          elLocale.use(langTR);
          break;
        case "en":
          dayjs.locale("en");
          dayjs.extend;
          elLocale.use(langEN);
          break;
        case "ru":
          dayjs.locale("ru");
          dayjs.extend;
          elLocale.use(langRU);
          break;
        case "zh-tw":
          dayjs.locale("zh-tw");
          dayjs.extend;
          elLocale.use(langZHCH);
          break;
        case "zh":
          dayjs.locale("zh");
          dayjs.extend;
          elLocale.use(langZHTW);
          break;
        case "de":
          dayjs.locale("de");
          dayjs.extend;
          elLocale.use(langDE);
          break;
      }
    },
  },
};
</script>
<style >
@media only screen and (max-width: 726px) {
  .login {
    padding-left: 0px !important;
    align-items: center;
  }
  .header {
    margin-top: 0px;
  }
  .login .el-card {
    width: 344px !important;
  }
}
</style>
<style scoped>
.header {
  margin-top: 50px;
}

.login {
  background: #f7f7f7;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: rgb(238, 237, 234);
  min-height: 100vh;
}

.login-button {
  width: 100%;
  margin-top: 40px;
}
.login-form {
  width: 290px;
}
.forgot-password {
  margin-top: 10px;
}
</style>
<style lang="scss">
.login .el-input__prefix {
  left: 0;
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: 3px;
  .el-input__icon {
    width: 30px;
  }
}
.login .el-input input {
  padding-left: 35px;
}
.login .el-card {
  padding-top: 0;
  padding-bottom: 30px;
}
h2 {
  font-family: "Open Sans";
  letter-spacing: 1px;
  font-family: Roboto, sans-serif;
}
// a {
//   color: $teal;
//   text-decoration: none;
//   &:hover,
//   &:active,
//   &:focus {
//     color: lighten($teal, 7);
//   }
// }
.login .el-card {
  width: 400px;
  display: flex;
  justify-content: center;
}
</style>
